import React from 'react';
import { Signal } from '@preact/signals-react';
import { FaTimes } from 'react-icons/fa';
import FileUpload from '../../../../molecules/FileUpload';

interface ContractFileUploadProps {
    contractFiles: Signal<File[]>;
    existingFile: string;
    removedFile: boolean;
    onRemove: () => void;
    onRestore: () => void;
    creditOperationId: string;
    onDownload: (creditOperationId: string, fileName: string) => void;
}

const ContractFileUpload: React.FC<ContractFileUploadProps> = ({
    contractFiles,
    existingFile,
    removedFile,
    onRemove,
    onRestore,
    creditOperationId,
    onDownload
}) => {
    return (
        <div>
            <h2 className="text-xl font-semibold mt-4 dark:text-white">Contrato</h2>
            <div className="mt-4">
                <FileUpload
                    id="contract-upload"
                    name="contract"
                    label="Upload do Contrato"
                    accept=".pdf,.doc,.docx"
                    errorMessage=""
                    onUploadFile={(file) => contractFiles.value = [file]}
                    onRemoveFile={() => contractFiles.value = []}
                />
                {existingFile && !removedFile && (
                    <div className="mt-2 p-2 bg-blue-50 dark:bg-blue-900/20 border border-blue-200 dark:border-blue-700 rounded flex justify-between items-center">
                        <p className="text-sm text-blue-700 dark:text-blue-300">
                            <strong>Arquivo atual:</strong>{' '}
                            <button type="button"
                                onClick={() => onDownload(creditOperationId, existingFile)}
                                className="underline hover:text-blue-900 dark:hover:text-blue-100 cursor-pointer bg-transparent border-0 p-0"
                            >
                                {existingFile}
                            </button>
                        </p>
                        <button type="button"
                            onClick={onRemove}
                            className="bg-red-500 text-white px-2 py-1 rounded text-xs hover:bg-red-600"
                        >
                            <FaTimes className="inline mr-1" /> Remover
                        </button>
                    </div>
                )}
                {removedFile && (
                    <div className="mt-2 p-2 bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-700 rounded flex justify-between items-center">
                        <p className="text-sm text-red-700 dark:text-red-300">
                            <strong>Arquivo removido:</strong> {existingFile}
                        </p>
                        <button type="button"
                            onClick={onRestore}
                            className="bg-green-500 text-white px-2 py-1 rounded text-xs hover:bg-green-600"
                        >
                            Restaurar
                        </button>
                    </div>
                )}
            </div>
        </div>
    );
};

export default ContractFileUpload;
